import React, { useEffect, useState } from 'react'
import { Api, pathJoin } from '../../../services/api';
import { ReactComponent as UserIcon } from './../../../assets/icons/user.svg';

import styles from './profilePhoto.module.css';

export const ProfilePhoto = ({userId, hasProfilePhoto, ...props}) => {

    /** @type [any, function(any): void] */
    const [data, setData] = useState({});

    const getData = async () => {
        await Api.cache(pathJoin('users', userId, 'profilePhoto'))
        .then(json => {
            if (json.content && json.content.length > 0)
                setData(json.content[0]);
            else
                setData({});
        })
        .catch(e => {
            setData({});
        });
    }

    useEffect(() => {
        if (userId && userId !== '' && hasProfilePhoto)
            getData()
    }, [userId, hasProfilePhoto]);

    return (
        <div className={styles.Picture} {...props}>
            <img className={data?.imageSrc ? styles.Active : ''} src={data?.imageSrc} />
            <div className={styles.Icon + ' icon'}><UserIcon /></div>
        </div>
    )
}